import { useNavigate, useParams } from 'react-router-dom';
import { appRoutes } from '../../path';
import { useQuery } from '@apollo/client';
import {
  IDashboardRedirectQueryQuery,
  IDashboardRedirectQueryQueryVariables,
} from '../../utils/apollo/graphqlSchema';
import { DASHBOARD_REDIRECT_QUERY } from '../../utils/apollo/dashboards';
import { assertNotNil } from '../../utils/types';

// In old way we used dashboardTemplateId in URLs.
// Nowadays, we use baseId. In order to get baseId -
// we have to run a query and then redirect user

export default () => {
  const navigate = useNavigate();
  const urlParams = useParams();
  const { dashboardTemplateId, instanceId } = urlParams;
  assertNotNil(dashboardTemplateId);

  const onDashboardBaseFromTemplateComplete = ({
    dashboard: { baseId },
  }: IDashboardRedirectQueryQuery) => {
    navigate({
      pathname: appRoutes.dashboard.generateLink(baseId, instanceId),
    });
  };

  useQuery<IDashboardRedirectQueryQuery, IDashboardRedirectQueryQueryVariables>(
    DASHBOARD_REDIRECT_QUERY,
    {
      variables: {
        id: dashboardTemplateId,
      },
      onCompleted: onDashboardBaseFromTemplateComplete,
    },
  );

  return null;
};
